<!-- Stack de FABs semitransparentes: no invasivos en reposo, se resaltan al hover.
     De abajo hacia arriba: Reportar (siempre), Mis errores, Administración. -->
<div class="issue-fab-stack">
    <button type="button" class="issue-fab" *ngIf="support.showAdmin && !onAdminScreen" (click)="goToAdmin()"
            aria-label="Administrar errores" title="Administrar errores reportados">
        <i class="pi pi-shield"></i>
        <span class="issue-fab__label">Administrar errores</span>
        <span class="issue-fab__badge">{{ support.pendingCount() }}</span>
    </button>

    <button type="button" class="issue-fab" *ngIf="support.showMyReports && !onMyIssuesScreen" (click)="goToMyIssues()"
            aria-label="Mis errores reportados" title="Mis errores reportados">
        <i class="pi pi-list"></i>
        <span class="issue-fab__label">Mis errores reportados</span>
        <span class="issue-fab__badge">{{ support.myCount() }}</span>
    </button>

    <button type="button" class="issue-fab" (click)="open()"
            aria-label="Reportar un issue" title="Reportar un issue (Ctrl + I)">
        <i class="pi pi-megaphone"></i>
        <span class="issue-fab__label">Reportar issue</span>
        <span class="issue-fab__kbd">Ctrl<span class="opacity-60">+</span>I</span>
    </button>
</div>

<p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [dismissableMask]="true"
          [style]="{width: '720px', maxWidth: '95vw'}" styleClass="premium-dialog issue-dialog"
          (onHide)="close()">

    <ng-template pTemplate="header">
        <div class="flex items-center gap-3">
            <div class="issue-dialog__badge"><i class="pi pi-megaphone"></i></div>
            <div>
                <h3 class="text-lg font-black text-white leading-tight">Reportar un issue</h3>
                <p class="text-[11px] text-white/70 font-medium">Cuéntanos qué pasó en esta pantalla</p>
            </div>
        </div>
    </ng-template>

    <div class="flex flex-col gap-5 pt-1" *ngIf="ctx">

        <!-- Contexto auto-detectado (inmutable) -->
        <div class="bg-sym-bg border border-sym-border rounded-xl p-4">
            <div class="flex items-center gap-2 mb-3">
                <p-tag value="AUTO" severity="success" styleClass="!text-[10px] !font-black !tracking-widest"></p-tag>
                <span class="text-[10px] font-black text-sym-gray-500 uppercase tracking-widest">Contexto detectado</span>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div class="issue-context__item">
                    <span class="issue-context__label">Pantalla</span>
                    <span class="issue-context__value">{{ ctx.detectedScreen || '—' }}</span>
                </div>
                <div class="issue-context__item">
                    <span class="issue-context__label">Proyecto activo</span>
                    <span class="issue-context__value">{{ ctx.projectName || 'Sin proyecto' }}</span>
                </div>
                <div class="issue-context__item md:col-span-2">
                    <span class="issue-context__label">Ruta</span>
                    <span class="issue-context__value issue-context__value--mono">{{ ctx.detectedRoute }}</span>
                </div>
                <div class="issue-context__item md:col-span-2">
                    <span class="issue-context__label">Navegador · Viewport</span>
                    <span class="issue-context__value issue-context__value--mono truncate">{{ ctx.userAgent }} · {{ ctx.viewport }}</span>
                </div>
            </div>
        </div>

        <!-- Tipo de issue -->
        <div class="flex flex-col gap-2">
            <label class="issue-label">Tipo</label>
            <p-selectButton [options]="typeOptions" optionLabel="label" optionValue="value"
                            [(ngModel)]="form.findingType" [allowEmpty]="false">
                <ng-template pTemplate="item" let-item>
                    <i [class]="item.icon" class="mr-2"></i>{{ item.label }}
                </ng-template>
            </p-selectButton>
        </div>

        <!-- Ubicación en cascada -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div class="flex flex-col gap-2">
                <label class="issue-label">Módulo</label>
                <p-dropdown [options]="modules" optionLabel="name" optionValue="testModuleId"
                            [(ngModel)]="form.moduleId" (onChange)="onModuleChange()"
                            placeholder="Selecciona" [filter]="true" filterBy="name"
                            [showClear]="true" appendTo="body" styleClass="w-full"></p-dropdown>
            </div>
            <div class="flex flex-col gap-2">
                <label class="issue-label">Submódulo</label>
                <p-dropdown [options]="submodules" optionLabel="name" optionValue="testSubmoduleId"
                            [(ngModel)]="form.submoduleId" (onChange)="onSubmoduleChange()"
                            placeholder="Opcional" [disabled]="!form.moduleId"
                            [showClear]="true" appendTo="body" styleClass="w-full"></p-dropdown>
            </div>
            <div class="flex flex-col gap-2">
                <label class="issue-label">Funcionalidad</label>
                <p-dropdown [options]="functionalities" optionLabel="name" optionValue="testFunctionalityId"
                            [(ngModel)]="form.functionalityId"
                            placeholder="Opcional" [disabled]="!form.submoduleId"
                            [showClear]="true" appendTo="body" styleClass="w-full"></p-dropdown>
            </div>
        </div>

        <!-- Título y descripción -->
        <div class="flex flex-col gap-2">
            <label class="issue-label">Título <span class="text-sym-danger">*</span></label>
            <input pInputText [(ngModel)]="form.findingTitle" maxlength="250" class="w-full"
                   placeholder="Ej: El total no cuadra al filtrar por rubro" />
        </div>

        <div class="flex flex-col gap-2">
            <label class="issue-label">Descripción <span class="text-sym-danger">*</span></label>
            <textarea pInputTextarea [(ngModel)]="form.description" rows="5" class="w-full"
                      placeholder="Pasos para reproducir… Resultado esperado… Resultado actual…"></textarea>
        </div>

        <!-- Modo, severidad y prioridad -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div class="flex flex-col gap-2">
                <label class="issue-label">Modo</label>
                <p-dropdown [options]="modeOptions" optionLabel="label" optionValue="value"
                            [(ngModel)]="form.reportMode" appendTo="body" styleClass="w-full"></p-dropdown>
            </div>
            <div class="flex flex-col gap-2">
                <label class="issue-label">Severidad</label>
                <p-dropdown [options]="severityOptions" optionLabel="label" optionValue="value"
                            [(ngModel)]="form.findingSeverity" appendTo="body" styleClass="w-full"></p-dropdown>
            </div>
            <div class="flex flex-col gap-2">
                <label class="issue-label">Prioridad</label>
                <p-dropdown [options]="priorityOptions" optionLabel="label" optionValue="value"
                            [(ngModel)]="form.findingPriority" appendTo="body" styleClass="w-full"></p-dropdown>
            </div>
        </div>

        <!-- Adjuntos: drag & drop + pegar desde el portapapeles -->
        <div class="flex flex-col gap-2">
            <label class="issue-label">Capturas</label>
            <div class="issue-dropzone" [class.issue-dropzone--over]="dragOver"
                 (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
                <i class="pi pi-image text-2xl text-sym-gray-500"></i>
                <p class="text-xs text-sym-gray-500 font-bold mt-2">
                    Arrastra imágenes aquí, pégalas con <span class="issue-kbd">Ctrl+V</span>
                    o <label for="issue-file-input" class="issue-browse">búscalas</label>
                </p>
                <input id="issue-file-input" type="file" multiple accept="image/*" class="hidden"
                       (change)="onFilesSelected($event)" />
            </div>

            <div class="flex flex-col gap-2 mt-1" *ngIf="files.length">
                <div *ngFor="let f of files; let i = index" class="issue-file">
                    <i class="pi pi-paperclip text-sym-gray-500"></i>
                    <span class="text-xs font-bold text-sym-ink truncate flex-1">{{ f.name }}</span>
                    <span class="text-[10px] text-sym-gray-500 font-black">{{ formatSize(f.size) }}</span>
                    <button type="button" class="issue-file__remove" (click)="removeFile(i)" aria-label="Quitar">
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex items-center justify-between gap-3 w-full">
            <span class="text-[10px] text-sym-gray-500 font-bold uppercase tracking-wider">
                Se reportará como {{ ctx?.projectName || 'sin proyecto' }}
            </span>
            <div class="flex gap-2">
                <button pButton label="Cancelar" class="p-button-text p-button-plain" (click)="close()"></button>
                <button pButton label="Enviar issue" icon="pi pi-send" class="px-6"
                        [disabled]="!canSubmit" [loading]="submitting" (click)="submit()"></button>
            </div>
        </div>
    </ng-template>
</p-dialog>
